export type RbimDisplayCodes = {
  provinceOrHucCode: string;
  municipalityCityCode: string;
  barangayCode: string;
};

export function parseRbimDisplayCodes(fullBarangayPsgcCode: string | null | undefined): RbimDisplayCodes {
  const clean = String(fullBarangayPsgcCode || "").replace(/\D/g, "");

  if (clean.length !== 10) {
    return {
      provinceOrHucCode: "",
      municipalityCityCode: "",
      barangayCode: "",
    };
  }

  return {
    provinceOrHucCode: clean.slice(2, 5),
    municipalityCityCode: clean.slice(5, 7),
    barangayCode: clean.slice(7, 10),
  };
}
